module.exports = __webpack_public_path__ + "static/fonts/rajdhani-bold-webfont.2309844.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/rajdhani-bold-webfont.woff
// module id = 95
// module chunks = 0